module.exports = __webpack_public_path__ + "img/hp-615.328c9e77.png";